import { RefObject, useEffect } from 'react';

export function useStickyHeaderOffset(
  headerRef: RefObject<HTMLElement>,
  options?: {
    cssVar?: string;
    precision?: number;
  }
) {
  useEffect(() => {
    const el = headerRef.current;
    if (!el || typeof IntersectionObserver === 'undefined') return;

    const cssVar = options?.cssVar ?? '--header-visible-h';
    const precision = options?.precision ?? 1;

    const thresholds = Array.from(
      { length: Math.floor(100 / precision) + 1 },
      (_, i) => i / (100 / precision)
    );

    const observer = new IntersectionObserver(
      ([entry]) => {
        const visible = entry.intersectionRect.height;

        document.documentElement.style.setProperty(
          cssVar,
          `${Math.max(0, visible)}px`
        );
      },
      { threshold: thresholds }
    );

    observer.observe(el);

    return () => observer.disconnect();
  }, [headerRef, options?.cssVar, options?.precision]);
}
